import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Page from 'react-page-loading'
import { getPortfolio } from '../api';
import _ from 'lodash';


const Portfolio = () => {
    const [classEl, setClass] = useState("");
    const [content, setContent] = useState([]);

    useEffect(() => {
        let isMounted = true;
        getPortfolio((res)=>{
            if(res && isMounted) setContent(res)
        })
        return () => { isMounted = false };
    }, [])


    setTimeout(() => {
        setClass("active")
    }, 300)

    if (_.isEmpty(content)) return false;
    return (

        // {/* <!-- ========== Start Portfolio ========== --> */}

        <section className={`portfolio area-bg ${classEl}`} id="portfolio">
            <Page loader={"rotate-spin"} color={"#A9A9A9"} size={6} duration={4}>
            <div className="container">
                <div className="main-title">
                    <h2>My Recent Works</h2>
                    <h3>My Portfolio</h3>
                </div>


                <div className="portfolio-content">
                    <div className="row">

                        {
                            content.map((project, index) => (
                                <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                                    <div className="item">
                                        <img className="img-fluid" src={project.image} alt="" />

                                        <div className="overlay">
                                            <h4 className="item-title">
                                                {project.title}
                                                <p className="portfolio-skill">({project.skill})</p>
                                            </h4>
                                            <div className="item-category">
                                                {/* <a className="icon-img portfolio-item-action" href={project.image}><i className="fa fa-search-plus"></i></a> */}
                                                <a className="icon-link portfolio-item-action" href={project.link}><i className="fa fa-search-plus"></i></a>
                                                {/* <a className="portfolio-item-action" href={project.link} target="_blank" rel="noopener noreferrer"><i className="fa fa-external-link"></i></a> */}
                                                {
                                                    project.path &&
                                                    <NavLink className="portfolio-item-action" to={`/code?path=${project.path}`} ><i className="fa fa-code"></i></NavLink>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
</Page>

        </section>

        // {/* <!-- ========== End Portfolio ========== --> */}

    );

}

export { Portfolio };
